import { AutoComplete, Modal as AModal } from "antd"
import { type ElementRef, type ReactNode, useEffect, useRef } from "react"

interface Option {
  label: ReactNode
  options: Array<{ value: string; label: ReactNode }>
}

const CommandPalette = ({
  options = [],
  // callbacks,
  getCallback,
  closeSearch,
}: {
  options: Option[]
  getCallback: (title: string) => void
  // callbacks: Record<string, () => void>;
  closeSearch: () => void
}) => {
  // const [searchText, setSearchText] = useState<string>();
  const ref = useRef<ElementRef<typeof AutoComplete>>(null)
  // const onSearch = (text: string) => setSearchText(text);

  useEffect(() => {
    // console.log("ref.current => ", ref.current)
    // if (ref.current) ref.current?.focus();

    setTimeout(() => ref.current?.focus(), 100)
  }, [])

  return (
    <AModal
      open
      footer={[]}
      style={{ top: 20 }}
      onCancel={closeSearch}
      onOk={closeSearch}
    >
      <AutoComplete
        defaultActiveFirstOption
        bordered={false}
        popupClassName="certain-category-search-dropdown"
        style={{ width: 250 }}
        options={options}
        filterOption
        ref={ref}
        autoFocus
        defaultOpen
        onBlur={closeSearch}
        onSelect={(val: string) => {
          getCallback(val)
          closeSearch()
        }}
        placeholder="Cmd / to search"
      ></AutoComplete>
    </AModal>
  )
}

export default CommandPalette
